module.exports = __webpack_public_path__ + "assets/retina_RhombusInTriangleDetailed.176e7367957d7ca7ba4ff4e169c7b630.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_RhombusInTriangleDetailed.png
// module id = 710
// module chunks = 0